import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { User } from '../../models/user';
import { MenuItem } from '../../models/menu-item';
import { HeaderAction } from '../../models/header-action';
import { HeaderActionsService } from '../../services/header-actions/header-actions.service';
import { UserSessionService } from '../../services/user-session/user-session.service';
import { EbookRoutingService } from '../../../e-book/services/ebook-routing/ebook-routing.service';
import { AppRoutes } from '../../Constants/app-routes';
import { StudentEnrollmentType } from '../../enums/student-enrollment-type';
import { AppConfigService } from '../../services/app-config/app-config.service';
import { AppMenuComponent } from './app-menu/app-menu.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { ClickOutsideDirective } from '../../directives/click-outside/click-outside.directive';

@Component({
    selector: 'app-header',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
    standalone: true,
    imports:[AppMenuComponent, UserInfoComponent, ClickOutsideDirective]
})
export class AppHeaderComponent implements OnInit {

  public isActiveSession: boolean;
  public user: User;
  @Input() menuItems: Array<MenuItem>;
  public applicationName: string = this.appConfig.config.applicationName;
  public environment: string = this.appConfig.config.Environment != '' ? `- ${this.appConfig.config.Environment}` : '';
  public isMenuOpened: boolean = false;
  public isUserInfoOpened: boolean = false;
  public isArchivedBtnActive: boolean = false;
  public actions: Array<HeaderAction> = [];
  public isMenuVisible: boolean = false;
  public toggleMenuImgSrc: string = "assets/imgs/menu.png";
  public get isRegisteredStudent(): boolean {
    return this.user ? this.user.isStudent && this.user.studentState == StudentEnrollmentType.Registered : false;
  }

  constructor(
    private _headerActionsService: HeaderActionsService,
    private _userSessionService: UserSessionService,
    private _routingService: EbookRoutingService,
    private changeDetector: ChangeDetectorRef,
    private appConfig: AppConfigService) { }

  ngOnInit(): void {
    this._headerActionsService.getHeaderActionsStream()
      .subscribe(actions => {
        this.actions = actions;
        this.changeDetector.detectChanges();
      });

    this.isActiveSession = this._userSessionService.isSessionActive();
    this.user = this._userSessionService.getUser();
    this._userSessionService.sessionStateChanged().subscribe((isActive) => {
      this.isMenuOpened = false;
      this.isUserInfoOpened = false;
      this.isActiveSession = isActive;
      this.user = this._userSessionService.getUser();
    });
    this.handleRouteChange();
  }

  public toggleMenu(): void {
    this.isMenuOpened = !this.isMenuOpened;
    this.isUserInfoOpened = false;
  }

  public toggleUserInfo(): void {
    this.isUserInfoOpened = !this.isUserInfoOpened;
  }

  public closeAll() {
    this.closeMenu();
    this.isUserInfoOpened = false;
  }

  public onHeaderActionClicked(action: HeaderAction) {
    this.notifyHeaderActionClicked(action);
    this.closeAll();
  }

  public viewArchivedBookshelf() {
    this._routingService.navigate(AppRoutes.archivedBookshelf);
  }

  public onClickOutSide() {
    this.closeAll();
  }

  private notifyHeaderActionClicked(action: HeaderAction): void {
    this._headerActionsService.notifyActionHeaderClicked(action.key);
  }

  private closeMenu() {
    this.isMenuVisible = false;
    this.isMenuOpened = false;
    this.toggleMenuImgSrc = "assets/imgs/menu.png";
  }

  private handleRouteChange() {
    this._routingService.onRouteChange
      .subscribe(url => {
        this.isArchivedBtnActive = url == AppRoutes.archivedBookshelf;
      });
  }

}
